/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Injectable } from "@angular/core";
import { ConnectedMessageService } from "./connected-message.service";
import { Logger } from "@html-core";

export enum BootstrapMessageType {
   ClientClosed = "client-closed",
   ClientOpened = "client-opened",
   BootstrapClosed = "bootstrap-closed"
}
export const SDKSyncName = "SDK-sync";
export const LifecycleName = "lifecycle";

@Injectable({
   providedIn: "root"
})
export class IndexMessageService {
   private clientId: string;
   private initialized: boolean = false;
   constructor(private connectedMessageService: ConnectedMessageService) {}

   public initialize(clientId, exitClientCallback): void {
      if (this.initialized) {
         Logger.warning("IndexMessageService already initialized");
         return;
      }
      this.initialized = true;
      this.clientId = clientId;
      this.connectedMessageService.initConnection(SDKSyncName, LifecycleName, "Window lifecycle management");
      window.addEventListener("beforeunload", () => {
         this.connectedMessageService.sendMessage(SDKSyncName, LifecycleName, {
            type: BootstrapMessageType.ClientClosed,
            clientId: this.clientId
         });
      });
      this.connectedMessageService.sendMessage(SDKSyncName, LifecycleName, {
         type: BootstrapMessageType.ClientOpened,
         clientId: this.clientId
      });
      this.connectedMessageService.onMessage(SDKSyncName, LifecycleName, (msg) => {
         if (msg.type === BootstrapMessageType.BootstrapClosed) {
            Logger.info("Received bootstrap closed message, exiting client");
            if (exitClientCallback) {
               exitClientCallback();
            }
         }
      });
      Logger.info("IndexMessageService initialized for SDK");
   }
}
